module.exports = __webpack_public_path__ + "static/img/mg.67f5922d.svg";